import { createSelector, createSlice } from "@reduxjs/toolkit";
import { logout } from "../common/reducers/initContext";
import { dataHookFactory, initMapFactory } from "../common/reducers/utilities";
import { ensureArray } from "../common/utils/arrayUtilities";
import { createEagerSelector, eagerMetaFactory } from "../common/reducers/pendingUpdateSlice";

const listNotesSlice = createSlice({
    name: 'listNotes',
    initialState: { 
        data: {}
    },
    reducers: {
        addOrUpdate: (state, action) => {
            for (const n of ensureArray(action.payload)) {
                const note = { ...n, autogenerated: n.autogenerated === 1 || n.autogenerated === '1' || n.autogenerated === true };
                if (!state.data[note.listentryid]) {
                    state.data[note.listentryid] = [note];
                } else {
                    let idx = state.data[note.listentryid].findIndex(a => note.id === a.id);
                    if (idx >= 0) {
                        state.data[note.listentryid].splice(idx, 1, note);
                    } else {
                        state.data[note.listentryid] = [...state.data[note.listentryid], note];
                    }
                }
            }
        },
    },
    extraReducers: builder => {
        builder.addCase(logout, () => listNotesSlice.getInitialState());
    }

});

// #region network operations
const eagerMeta = eagerMetaFactory(listNotesSlice.name);
const fetchListNotes = listentryid => network => network.get(`/api/v1/listnotes/${encodeURIComponent(listentryid)}`, listNotesSlice.actions.addOrUpdate);
export const strikeListNote = (network, data) => network.put('/api/v1/listnote', data, listNotesSlice.actions.addOrUpdate, eagerMeta(data.id, { fk: data.listentryid })); // TODO better failure
export const addListNote = (network, data) => network.post('/api/v1/listnote', { ...data, autogenerated: data.autogenerated === true || data.autogenerated === '1' || data.autogenerated === 1 ? 1 : 0 }, listNotesSlice.actions.addOrUpdate, eagerMeta(data.id, { fk: data.listentryid })); // TODO better failure)
// #endregion

// #region selectors
const selectAllListNotes = state => state.listNotes.data;

const eagerSelector = createEagerSelector(listNotesSlice.name, { mode: 'mapToArray' });
const selectListNotesByID = eagerSelector(createSelector([selectAllListNotes, (notes, listentryid) => listentryid], (notes, listentryid) => {
    return notes[listentryid] ?? []
}));
const selectListNotes = listentryid => state => selectListNotesByID(state, listentryid);

// #endregion

// #region listeners
const listen = {
    listNoteAdded: (note, { dispatch }) => dispatch(listNotesSlice.actions.addOrUpdate(note)),
    listNoteStruck: (note, { dispatch }) => dispatch(listNotesSlice.actions.addOrUpdate(note))
}
// #endregion 

export const [useListNotes] = dataHookFactory(selectListNotes, initMapFactory(fetchListNotes, listen, listentryid => listentryid?.toString()));

const reducerDetails = { name: listNotesSlice.name, reducer: listNotesSlice.reducer };
export default reducerDetails;